// **  Initial State
const initialState = {
    allData: [],
    selected: null
}

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_USERS':
            return { ...state, allData:[...state.allData.concat(action.data)]  }
        case 'GET_USERS':
            return { ...state, allData: action.data }
        case 'SELECTED_USER':
            return { ...state, selected: action.data }
        case 'UPDATE_USER':
            return {
                ...state,
                allData: [
                    ...state.allData.filter(user => user.id !== action.data.id),
                    action.data
                ]
            }
        case 'DELETE_USER':
            return {
                ...state,
                allData: state.allData.filter(user => {return user.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default userReducer
